// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var DeccoUtils$SmartcutsMacros = require("../../../bs-utils/src/DeccoUtils.bs.js");

var UpdateSpreadsheetPropertiesRequest = {};

var UpdateSheetPropertiesRequest = {};

var UpdateDimensionPropertiesRequest = {};

var UpdateNamedRangeRequest = {};

var RepeatCellRequest = {};

var AddNamedRangeRequest = {};

var DeleteNamedRangeRequest = {};

var AddSheetRequest = {};

var DeleteSheetRequest = {};

var AutoFillRequest = {};

var CutPasteRequest = {};

var CopyPasteRequest = {};

var MergeCellsRequest = {};

var UnmergeCellsRequest = {};

var UpdateBordersRequest = {};

var UpdateCellsRequest = {};

var AddFilterViewRequest = {};

var AppendCellsRequest = {};

var ClearBasicFilterRequest = {};

var DeleteDimensionRequest = {};

var DeleteEmbeddedObjectRequest = {};

var DeleteFilterViewRequest = {};

var DuplicateFilterViewRequest = {};

var DuplicateSheetRequest = {};

var FindReplaceRequest = {};

var InsertDimensionRequest = {};

var InsertRangeRequest = {};

var MoveDimensionRequest = {};

var UpdateEmbeddedObjectPositionRequest = {};

var PasteDataRequest = {};

var TextToColumnsRequest = {};

var UpdateFilterViewRequest = {};

var DeleteRangeRequest = {};

var AppendDimensionRequest = {};

var AddConditionalFormatRuleRequest = {};

var UpdateConditionalFormatRuleRequest = {};

var DeleteConditionalFormatRuleRequest = {};

var SortRangeRequest = {};

var SetDataValidationRequest = {};

var SetBasicFilterRequest = {};

var AddProtectedRangeRequest = {};

var UpdateProtectedRangeRequest = {};

var DeleteProtectedRangeRequest = {};

var AutoResizeDimensionsRequest = {};

var AddChartRequest = {};

var UpdateChartSpecRequest = {};

var UpdateBandingRequest = {};

var AddBandingRequest = {};

var DeleteBandingRequest = {};

var CreateDeveloperMetadataRequest = {};

var UpdateDeveloperMetadataRequest = {};

var DeleteDeveloperMetadataRequest = {};

var RandomizeRangeRequest = {};

var AddDimensionGroupRequest = {};

var DeleteDimensionGroupRequest = {};

var UpdateDimensionGroupRequest = {};

var TrimWhitespaceRequest = {};

var DeleteDuplicatesRequest = {};

var UpdateEmbeddedObjectBorderRequest = {};

var AddSlicerRequest = {};

var UpdateSlicerSpecRequest = {};

var AddDataSourceRequest = {};

var UpdateDataSourceRequest = {};

var DeleteDataSourceRequest = {};

var RefreshDataSourceRequest = {};

var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});

var t_encode = include.t_encode;

var t_decode = include.t_decode;

var $$Request = {
  t_encode: t_encode,
  t_decode: t_decode
};

var Requests = {
  UpdateSpreadsheetPropertiesRequest: UpdateSpreadsheetPropertiesRequest,
  UpdateSheetPropertiesRequest: UpdateSheetPropertiesRequest,
  UpdateDimensionPropertiesRequest: UpdateDimensionPropertiesRequest,
  UpdateNamedRangeRequest: UpdateNamedRangeRequest,
  RepeatCellRequest: RepeatCellRequest,
  AddNamedRangeRequest: AddNamedRangeRequest,
  DeleteNamedRangeRequest: DeleteNamedRangeRequest,
  AddSheetRequest: AddSheetRequest,
  DeleteSheetRequest: DeleteSheetRequest,
  AutoFillRequest: AutoFillRequest,
  CutPasteRequest: CutPasteRequest,
  CopyPasteRequest: CopyPasteRequest,
  MergeCellsRequest: MergeCellsRequest,
  UnmergeCellsRequest: UnmergeCellsRequest,
  UpdateBordersRequest: UpdateBordersRequest,
  UpdateCellsRequest: UpdateCellsRequest,
  AddFilterViewRequest: AddFilterViewRequest,
  AppendCellsRequest: AppendCellsRequest,
  ClearBasicFilterRequest: ClearBasicFilterRequest,
  DeleteDimensionRequest: DeleteDimensionRequest,
  DeleteEmbeddedObjectRequest: DeleteEmbeddedObjectRequest,
  DeleteFilterViewRequest: DeleteFilterViewRequest,
  DuplicateFilterViewRequest: DuplicateFilterViewRequest,
  DuplicateSheetRequest: DuplicateSheetRequest,
  FindReplaceRequest: FindReplaceRequest,
  InsertDimensionRequest: InsertDimensionRequest,
  InsertRangeRequest: InsertRangeRequest,
  MoveDimensionRequest: MoveDimensionRequest,
  UpdateEmbeddedObjectPositionRequest: UpdateEmbeddedObjectPositionRequest,
  PasteDataRequest: PasteDataRequest,
  TextToColumnsRequest: TextToColumnsRequest,
  UpdateFilterViewRequest: UpdateFilterViewRequest,
  DeleteRangeRequest: DeleteRangeRequest,
  AppendDimensionRequest: AppendDimensionRequest,
  AddConditionalFormatRuleRequest: AddConditionalFormatRuleRequest,
  UpdateConditionalFormatRuleRequest: UpdateConditionalFormatRuleRequest,
  DeleteConditionalFormatRuleRequest: DeleteConditionalFormatRuleRequest,
  SortRangeRequest: SortRangeRequest,
  SetDataValidationRequest: SetDataValidationRequest,
  SetBasicFilterRequest: SetBasicFilterRequest,
  AddProtectedRangeRequest: AddProtectedRangeRequest,
  UpdateProtectedRangeRequest: UpdateProtectedRangeRequest,
  DeleteProtectedRangeRequest: DeleteProtectedRangeRequest,
  AutoResizeDimensionsRequest: AutoResizeDimensionsRequest,
  AddChartRequest: AddChartRequest,
  UpdateChartSpecRequest: UpdateChartSpecRequest,
  UpdateBandingRequest: UpdateBandingRequest,
  AddBandingRequest: AddBandingRequest,
  DeleteBandingRequest: DeleteBandingRequest,
  CreateDeveloperMetadataRequest: CreateDeveloperMetadataRequest,
  UpdateDeveloperMetadataRequest: UpdateDeveloperMetadataRequest,
  DeleteDeveloperMetadataRequest: DeleteDeveloperMetadataRequest,
  RandomizeRangeRequest: RandomizeRangeRequest,
  AddDimensionGroupRequest: AddDimensionGroupRequest,
  DeleteDimensionGroupRequest: DeleteDimensionGroupRequest,
  UpdateDimensionGroupRequest: UpdateDimensionGroupRequest,
  TrimWhitespaceRequest: TrimWhitespaceRequest,
  DeleteDuplicatesRequest: DeleteDuplicatesRequest,
  UpdateEmbeddedObjectBorderRequest: UpdateEmbeddedObjectBorderRequest,
  AddSlicerRequest: AddSlicerRequest,
  UpdateSlicerSpecRequest: UpdateSlicerSpecRequest,
  AddDataSourceRequest: AddDataSourceRequest,
  UpdateDataSourceRequest: UpdateDataSourceRequest,
  DeleteDataSourceRequest: DeleteDataSourceRequest,
  RefreshDataSourceRequest: RefreshDataSourceRequest,
  $$Request: $$Request
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "requests",
                Decco.arrayToJson(t_encode, v.requests)
              ],
              [
                "includeSpreadsheetInResponse",
                DeccoUtils$SmartcutsMacros.Nullable.t_encode(Decco.boolToJson, v.includeSpreadsheetInResponse)
              ],
              [
                "responseRanges",
                DeccoUtils$SmartcutsMacros.Nullable.t_encode((function (param) {
                        return Decco.arrayToJson(Decco.stringToJson, param);
                      }), v.responseRanges)
              ],
              [
                "responseIncludeGridData",
                DeccoUtils$SmartcutsMacros.Nullable.t_encode(Decco.boolToJson, v.responseIncludeGridData)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var requests = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "requests"), null));
  if (requests.TAG === /* Ok */0) {
    var includeSpreadsheetInResponse = DeccoUtils$SmartcutsMacros.Nullable.t_decode(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "includeSpreadsheetInResponse"), null));
    if (includeSpreadsheetInResponse.TAG === /* Ok */0) {
      var responseRanges = DeccoUtils$SmartcutsMacros.Nullable.t_decode((function (param) {
              return Decco.arrayFromJson(Decco.stringFromJson, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "responseRanges"), null));
      if (responseRanges.TAG === /* Ok */0) {
        var responseIncludeGridData = DeccoUtils$SmartcutsMacros.Nullable.t_decode(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "responseIncludeGridData"), null));
        if (responseIncludeGridData.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    requests: requests._0,
                    includeSpreadsheetInResponse: includeSpreadsheetInResponse._0,
                    responseRanges: responseRanges._0,
                    responseIncludeGridData: responseIncludeGridData._0
                  }
                };
        }
        var e = responseIncludeGridData._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".responseIncludeGridData" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = responseRanges._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".responseRanges" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = includeSpreadsheetInResponse._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".includeSpreadsheetInResponse" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = requests._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".requests" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function make(requests, includeSpreadsheetInResponseOpt, responseRangesOpt, responseIncludeGridDataOpt, param) {
  var includeSpreadsheetInResponse = includeSpreadsheetInResponseOpt !== undefined ? Caml_option.valFromOption(includeSpreadsheetInResponseOpt) : null;
  var responseRanges = responseRangesOpt !== undefined ? Caml_option.valFromOption(responseRangesOpt) : null;
  var responseIncludeGridData = responseIncludeGridDataOpt !== undefined ? Caml_option.valFromOption(responseIncludeGridDataOpt) : null;
  return {
          requests: requests,
          includeSpreadsheetInResponse: includeSpreadsheetInResponse,
          responseRanges: responseRanges,
          responseIncludeGridData: responseIncludeGridData
        };
}

var RequestBody = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  make: make
};

var $$Response = {};

var Responses = {
  $$Response: $$Response
};

exports.Requests = Requests;
exports.RequestBody = RequestBody;
exports.Responses = Responses;
/* include Not a pure module */
